// Auto-generated from public/voice/coach_greeting.mp3 via mlx-whisper (word timestamps).
// Regenerate when the coach clip changes. Edit the word text here if a word is off.

export interface CaptionWord {
  /** Start time in seconds within the clip. */
  t: number;
  w: string;
}

export interface CaptionLine {
  start: number;
  end: number;
  words: CaptionWord[];
}

export const SPLASH_CAPTIONS: CaptionLine[] = [
  {
    start: 0.0,
    end: 2.1,
    words: [
      { t: 0.0, w: 'Hey,' },
      { t: 0.68, w: 'I' },
      { t: 1.0, w: 'might' },
      { t: 1.2, w: 'have' },
      { t: 1.32, w: 'startled' },
      { t: 1.66, w: 'you.' },
    ],
  },
  {
    start: 2.1,
    end: 3.36,
    words: [
      { t: 2.1, w: "You're" },
      { t: 2.4, w: 'probably' },
      { t: 2.66, w: 'not' },
      { t: 2.88, w: 'used' },
      { t: 3.1, w: 'to' },
      { t: 3.24, w: 'an' },
    ],
  },
  {
    start: 3.36,
    end: 4.78,
    words: [
      { t: 3.36, w: 'app' },
      { t: 3.66, w: 'just' },
      { t: 3.9, w: 'talking' },
      { t: 4.22, w: 'to' },
      { t: 4.44, w: 'you.' },
    ],
  },
  {
    start: 4.78,
    end: 6.26,
    words: [
      { t: 4.78, w: "I'm" },
      { t: 5.18, w: 'your' },
      { t: 5.3, w: 'AI' },
      { t: 5.56, w: 'coach' },
      { t: 5.92, w: 'here' },
      { t: 6.12, w: 'at' },
    ],
  },
  {
    start: 6.26,
    end: 8.1,
    words: [
      { t: 6.26, w: 'your' },
      { t: 6.38, w: 'service' },
      { t: 6.78, w: 'at' },
      { t: 6.94, w: 'Guided' },
      { t: 7.24, w: 'Growth,' },
      { t: 7.58, w: 'and' },
    ],
  },
  {
    start: 8.1,
    end: 9.2,
    words: [
      { t: 8.1, w: "I'm" },
      { t: 8.22, w: 'excited' },
      { t: 8.5, w: 'to' },
      { t: 8.66, w: 'help' },
      { t: 8.78, w: 'you' },
      { t: 8.92, w: 'improve' },
    ],
  },
  {
    start: 9.2,
    end: 10.1,
    words: [
      { t: 9.2, w: 'things' },
      { t: 9.44, w: 'in' },
      { t: 9.6, w: 'your' },
      { t: 9.68, w: 'life' },
      { t: 9.88, w: 'that' },
      { t: 10.0, w: 'are' },
    ],
  },
  {
    start: 10.1,
    end: 10.82,
    words: [
      { t: 10.1, w: 'important' },
      { t: 10.4, w: 'to' },
      { t: 10.6, w: 'you.' },
    ],
  },
  {
    start: 10.82,
    end: 12.4,
    words: [
      { t: 10.82, w: 'So' },
      { t: 11.22, w: "let's" },
      { t: 11.42, w: 'get' },
      { t: 11.56, w: 'you' },
      { t: 11.7, w: 'in,' },
      { t: 11.98, w: 'and' },
    ],
  },
  {
    start: 12.4,
    end: 12.96,
    words: [
      { t: 12.4, w: "we'll" },
      { t: 12.52, w: 'get' },
      { t: 12.66, w: 'started.' },
    ],
  },
];
